module.exports = __webpack_public_path__ + "img/router.b62607c7.svg";